var A = /* @__PURE__ */ ((E) => (E.greenToRed = "greenToRed", E.redToGreen = "redToGreen", E.baseDarkToLight = "baseDarkToLight", E.baseLightToDark = "baseLightToDark", E))(A || {}), e = /* @__PURE__ */ ((E) => (E.FILTER = "FILTER", E.PERIOD = "PERIOD", E.GROWTH = "GROWTH", E))(e || {}), R = /* @__PURE__ */ ((E) => (E["blue-border"] = "blue-border", E["blue-pastel"] = "blue-pastel", E["orange-border"] = "orange-border", E["orange-pastel"] = "orange-pastel", E["red-border"] = "red-border", E["red-pastel"] = "red-pastel", E["green-border"] = "green-border", E["green-pastel"] = "green-pastel", E["bluegreen-border"] = "bluegreen-border", E["bluegreen-pastel"] = "bluegreen-pastel", E))(R || {}), n = /* @__PURE__ */ ((E) => (E.VALUE = "VALUE", E.DIFFERENCE = "DIFFERENCE", E.RATIO = "RATIO", E))(n || {}), _ = /* @__PURE__ */ ((E) => (E.growthInvert = "growthInvert", E.isDisplayedOnSecondaryAxis = "isDisplayedOnSecondaryAxis", E.growthLabel = "growthLabel", E.units = "units", E.color = "color", E.decimals = "decimals", E))(_ || {}), d = /* @__PURE__ */ ((E) => (E.AXIS = "AXIS", E.BAR = "BAR", E.AREA = "AREA", E.LINE = "LINE", E.PART = "PART", E.TABLE = "TABLE", E.COLOR = "COLOR", E.NUMBER = "NUMBER", E))(d || {}), I = /* @__PURE__ */ ((E) => (E.GAUGE = "gauge", E.AREA = "area", E.LINE = "lines", E.BOXES = "boxes", E.BARS = "bars", E.SCATTER = "scatter", E.TABLES = "tables", E.PIE = "pie", E))(I || {}), D = /* @__PURE__ */ ((E) => (E.VERTICAL = "VERTICAL", E.HORIZONTAL = "HORIZONTAL", E.V_GROUPED = "V_GROUPED", E.H_GROUPED = "H_GROUPED", E.V_STACKED = "V_STACKED", E.H_STACKED = "H_STACKED", E.PERCENTAGE_H_STACKED = "PERCENTAGE_H_STACKED", E.PERCENTAGE_V_STACKED = "PERCENTAGE_V_STACKED", E.AREA_STANDARD = "AREA_STANDARD", E.LINE_STANDARD = "LINE_STANDARD", E.PIE_STANDARD = "PIE_STANDARD", E.ECLATE = "ECLATE", E.DONUT = "DONUT", E.AREA_PERCENTAGE = "AREA_PERCENTAGE", E.GAUGE_CIRCLE = "GAUGE_CIRCLE", E))(D || {}), b = /* @__PURE__ */ ((E) => (E.blue_border = "#425FF0", E.blue_pastel = "#7CE0DA", E.orange_border = "#FA9866", E.orange_pastel = "#F6D010", E.red_border = "#EE6873", E.red_pastel = "#FFB9B3", E.green_border = "#83CF60", E.green_pastel = "#2A9E9C", E.purple_border = "#A962F0", E.purple_pastel = "#C8A1FF", E))(b || {});
const l = /* @__PURE__ */ new Map([
  [
    "blue-border",
    "#425FF0"
    /* blue_border */
  ],
  [
    "blue-pastel",
    "#7CE0DA"
    /* blue_pastel */
  ],
  [
    "orange-border",
    "#FA9866"
    /* orange_border */
  ],
  [
    "orange-pastel",
    "#F6D010"
    /* orange_pastel */
  ],
  [
    "red-border",
    "#EE6873"
    /* red_border */
  ],
  [
    "red-pastel",
    "#FFB9B3"
    /* red_pastel */
  ],
  [
    "green-border",
    "#83CF60"
    /* green_border */
  ],
  [
    "green-pastel",
    "#2A9E9C"
    /* green_pastel */
  ],
  [
    "bluegreen-border",
    "#A962F0"
    /* purple_border */
  ],
  [
    "bluegreen-pastel",
    "#C8A1FF"
    /* purple_pastel */
  ]
]);
var O = /* @__PURE__ */ ((E) => (E.DAY_MINUS_ONE = "d-n", E.WEEK_MINUS_ONE = "w-n", E.MONTH_MINUS_ONE = "m-n", E.QUARTER_MINUS_ONE = "q-n", E.SEMESTER_MINUS_ONE = "s-1", E.YEAR_MINUS_ONE = "y-n", E.DAY_MINUS_THIRTY = "d-30", E.TRANSLATED = "previous", E))(O || {}), u = /* @__PURE__ */ ((E) => (E.previous = "previous", E["d-n"] = "d-n", E["w-n"] = "w-n", E["m-n"] = "m-n", E["q-n"] = "q-n", E["y-n"] = "y-n", E))(u || {}), N = /* @__PURE__ */ ((E) => (E["last-period"] = "last-period", E["dynamic-period"] = "dynamic-period", E))(N || {});
const U = Object.freeze([
  { value: "RATIO", label: "growth.type-preset.ratio" },
  { value: "DIFFERENCE", label: "growth.type-preset.difference" },
  { value: "VALUE", label: "growth.type-preset.value" }
]);
var S = /* @__PURE__ */ ((E) => (E.TARGET = "TARGET", E.PART = "PART", E.BAR = "BAR", E.AREA = "AREA", E.LINE = "LINE", E.NUMBER = "NUMBER", E.COLUMN = "COLUMN", E.XAXIS = "XAXIS", E.YAXIS = "YAXIS", E.SIZE = "SIZE", E))(S || {}), L = /* @__PURE__ */ ((E) => (E.PART = "PART", E.AXE = "AXE", E.COLOR = "COLOR", E.COLUMN = "COLUMN", E.POINTS = "POINTS", E))(L || {}), s = /* @__PURE__ */ ((E) => (E.CLASSIC = "Classic", E.DOUBLE = "Double", E.ARRAY = "Array", E))(s || {}), T = /* @__PURE__ */ ((E) => (E["d-"] = "d-", E["w-"] = "w-", E["m-"] = "m-", E["q-"] = "q-", E["y-"] = "y-", E))(T || {});
export {
  D as ChartFormat,
  O as ChartGrowth,
  R as ColorName,
  b as Colors,
  I as GenericChartTypes,
  A as GradientType,
  N as GrowthGroup,
  u as GrowthLabel,
  T as GrowthPreffix,
  _ as MetricExtraConfKeys,
  n as MetricGrowthType,
  S as MetricTarget,
  e as MetricTitlePart,
  L as SlicerTarget,
  s as SortType,
  d as TargetAffect,
  U as growthTypes,
  l as strToColor
};
//# sourceMappingURL=types.js.map
